import './style.scss';

function Textarea(props) {
  return (
    <textarea className={"Textarea " + props.className} type={props.type} name={props.name} id={props.id} placeholder={props.placeholder} onChange={props.onChange} onBlur={props.onBlur} value={props.children}></textarea>
  );
}

export default Textarea;
